"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

require("core-js/modules/es6.function.bind.js");

require("core-js/modules/es6.array.filter.js");

require("core-js/modules/es6.array.map.js");

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/newArrowCheck"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactComponents = require("@ucloud-fe/react-components");

var _style = require("./style");

var _ProjectSelect = require("./ProjectSelect");

var _this = void 0;

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable react/prop-types */
var Projects = function Projects(props) {
  var _this2 = this;

  (0, _newArrowCheck2["default"])(this, _this);
  var locale = props.locale,
      _props$items = props.items,
      items = _props$items === void 0 ? [] : _props$items,
      onDefaultChange = props.onDefaultChange,
      onProjectChange = props.onProjectChange,
      currentProject = props.currentProject,
      bottom = props.bottom;

  var _useState = (0, _react.useState)(""),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      searchVal = _useState2[0],
      setSearchVal = _useState2[1];

  var searchedItems = items.filter(function (item) {
    (0, _newArrowCheck2["default"])(this, _this2);
    return item.ProjectName.indexOf(searchVal) >= 0;
  }.bind(this));

  function handleInputChange(e) {
    setSearchVal(e.target.value);
  }

  function handleChange(_ref) {
    var _ref2 = (0, _slicedToArray2["default"])(_ref, 1),
        projectId = _ref2[0];

    onProjectChange(projectId);
  }

  function handleSetDefaultProject(projectId) {
    onDefaultChange(projectId);
  }

  return /*#__PURE__*/_react["default"].createElement(_style.ProjectsWrapper, null, (searchVal || searchedItems.length > 7) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(_style.prefixCls, "-search")
  }, /*#__PURE__*/_react["default"].createElement(_reactComponents.Input, {
    value: searchVal,
    style: {
      width: "100%"
    },
    onClick: function (e) {
      (0, _newArrowCheck2["default"])(this, _this2);
      e.nativeEvent.stopImmediatePropagation();
    }.bind(this),
    onChange: handleInputChange,
    suffix: /*#__PURE__*/_react["default"].createElement(_reactComponents.Icon, {
      type: "search",
      prefix: "icon-uc-action__"
    })
  })), /*#__PURE__*/_react["default"].createElement(_style.BlockMenu, {
    onChange: handleChange,
    selectedKeys: [currentProject === null || currentProject === void 0 ? void 0 : currentProject.ProjectId]
  }, searchedItems.map(function (item) {
    var _this3 = this;

    (0, _newArrowCheck2["default"])(this, _this2);
    return /*#__PURE__*/_react["default"].createElement(_reactComponents.Menu.Item, {
      itemKey: item.ProjectId,
      key: item.ProjectId,
      style: {
        paddingRight: 0
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(_style.prefixCls, "-menu-item ")
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(_style.prefixCls, "-menu-item-name")
    }, item.ProjectName), item.IsDefault ? /*#__PURE__*/_react["default"].createElement(_reactComponents.Tooltip, {
      popup: locale.defaultTip,
      placement: "right"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "".concat(_style.prefixCls, "-menu-item-icon-default"),
      onClick: function (e) {
        (0, _newArrowCheck2["default"])(this, _this3);
        // 点击默认项 icon 时，不触发项目切换
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
      }.bind(this)
    }, "D")) : /*#__PURE__*/_react["default"].createElement(_reactComponents.Tooltip, {
      popup: locale.setDefault,
      placement: "right"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "".concat(_style.prefixCls, "-menu-item-icon"),
      onClick: function (e) {
        (0, _newArrowCheck2["default"])(this, _this3);
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        handleSetDefaultProject(item.ProjectId);
      }.bind(this)
    }, "D"))));
  }.bind(this))), bottom && /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(_style.prefixCls, "-bottom")
  }, bottom));
}.bind(void 0);

Projects.propTypes = {
  /**
   * 项目列表
   */
  items: _propTypes["default"].arrayOf(_propTypes["default"].shape(_ProjectSelect.projectItemShape)),

  /**
   * 选中的 project
   */
  currentProject: _propTypes["default"].shape(_ProjectSelect.projectItemShape),

  /**
   * 设置默认项函数
   */
  onDefaultChange: _propTypes["default"].func,

  /**
   * 选中变化时的回调
   */
  onProjectChange: _propTypes["default"].func,

  /**
   * 底部的操作项，例如：跳转到账号管理函数
   */
  bottom: _propTypes["default"].node
};
Projects.defaultProps = {
  items: [],
  currentProject: {},
  onDefaultChange: function onDefaultChange() {
    (0, _newArrowCheck2["default"])(this, _this);
  }.bind(void 0),
  onProjectChange: function onProjectChange() {
    (0, _newArrowCheck2["default"])(this, _this);
  }.bind(void 0)
};
var _default = Projects;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/ProjectSelect/Projects.js
// module id = 2132
// module chunks = 6 7 17 18